import React from 'react';
import PropTypes from 'prop-types';
import { QueryRenderer, graphql } from 'react-relay';

import FolderWrapperWrapper from '../../../sharedComponents/FolderWrapperWrapper';

const bulkActionsRendererQuery = graphql`
    query BulkActionsFolderRendererRendererQuery(
        $userIds: [String]!
        $selectedItemIds: [String]!
        $shouldFillInFolder: Boolean!
    ) {
        viewer {
            ...FolderWrapperWrapper_viewer
        }
    }
`;

function BulkActionsFolderRenderer({ environment, ...props }) {
    const variables = {
        selectedItemIds: props.selectedItemIds,
        shouldFillInFolder: !!props.userId,
        userIds: [props.userId],
    };

    return (
        <QueryRenderer
            environment={environment}
            query={bulkActionsRendererQuery}
            variables={variables}
            render={({ props: relayProps }) => {
                if (!relayProps) {
                    return null;
                }
                return <FolderWrapperWrapper {...props} />;
            }}
        />
    );
}

BulkActionsFolderRenderer.propTypes = {
    environment: PropTypes.object.isRequired,
    userType: PropTypes.string,
    userId: PropTypes.string,
};

export { BulkActionsFolderRenderer };
